import { useEffect, useState, useCallback } from 'react';
import './ProfilePage.css';
import useActiveEmployeeId from '@frontend/AppSettings/hooks/useActiveEmployeeId';
// import { faEdit, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Templates from './Components/Templates/Templates';
import ProfileWorkflow from './Components/Create&UpdateWorkflow/ProflieWorkflow';
import PersonalWidget from './Components/PersonalWidget/PersonalWidget';
import CustomFields from './Components/CustomFields/CustomField';
import TemplateEdit from './Components/Eng_templates/TemplateEdit';
import EmployeeService from '../AppSettings/services/EmployeeService';
// import AddButton from '../Components/AddButton/AddButton';
import { isLegalEnvironment } from '../AppSettings/environmentConfig';

const Profile = () => {
  const employeeId = useActiveEmployeeId();
  const [currentEmployee, setCurrentEmployee] = useState(null);

  // Fetch employee data for both operations and permissions
  const fetchEmployeeData = useCallback(async () => {
    if (employeeId) {
      try {
        const employeeData = await EmployeeService.getEmployeeById(employeeId);
        setCurrentEmployee(employeeData);
      } catch (error) {
        console.error('Error fetching employee data:', error);
      }
    }
  }, [employeeId]);

  useEffect(() => {
    fetchEmployeeData();
  }, [fetchEmployeeData]);

  return (
    <div className="profile-container">
      <div className="profile-top">
        <div className="personal-widget-container">
          <PersonalWidget />
        </div>
        <div className="rules-templates-container">
          {!isLegalEnvironment && (
            <div className="rule-container">
              <TemplateEdit permishId={currentEmployee?.permish_id} />
            </div>
          )}
          <div
            className={`profile-templates-container ${
              isLegalEnvironment ? 'legal-templates' : 'eng-templates'
            }`}
          >
            <Templates />
          </div>
        </div>
      </div>
      <div className="profile-bottom">
        <div className="profile-bottom-content">
          <div className="custom-fields-section">
            <CustomFields />
          </div>
          <div className="profile-workflow-section">
            <ProfileWorkflow />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
